import React from 'react';
import Table from 'react-bootstrap/Table';
import { Entente } from '../../../../../../common/src/entities';
interface DynamicTableDetailsProps {
    data: Entente,
    title: string;
}

const DynamicTableDetails: React.FC<DynamicTableDetailsProps> = ({ data, title }) => {
    return (
        <div>
            <p>{title}</p>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Nom</th>
                        <th>Date de l'activité</th>
                        <th>Conditions</th>
                        <th>Contexte</th>
                        <th>Groupe d'âge</th>
                    </tr>
                </thead>
                <tbody>
                    <td>{data.name}</td>
                    <td>{data.date_activite?.split('T')[0]}</td>
                    <td>{data.conditions}</td>
                    <td>{data.contexte}</td>
                    <td>{data.groupe_age}</td>
                </tbody>
            </Table>
        </div>
    );
};

export default DynamicTableDetails;